import React, { FunctionComponent } from 'react';
import { Dialog } from '@liveramp/motif/core/Dialog';
import Button from '@liveramp/motif/core/Button';
import { CampaignStatus } from '../filterOptions.enum';
import useCampaignStatusModalLogic from './useCampaignStatusModalLogic';
import StatusOption from './StatusOption';
import styles from './styles.module.scss';

interface Props {
  isDialogOpened: boolean;
  onCloseDialog: () => void;
  setCampaignStatusFilter: (status: CampaignStatus[]) => void;
  campaignStatusFilter: CampaignStatus[];
  boundingCampaignButtonRect: any;
}

const CampaignStatusModal: FunctionComponent<Props> = ({
  isDialogOpened,
  onCloseDialog,
  setCampaignStatusFilter,
  campaignStatusFilter,
  boundingCampaignButtonRect
}) => {
  const {
    options,
    onOptionChange,
    useStyles
  } = useCampaignStatusModalLogic(campaignStatusFilter, isDialogOpened, boundingCampaignButtonRect);

  return (
    <Dialog
      open={isDialogOpened}
      onClose={onCloseDialog}
      onBackdropClick={onCloseDialog}
      onEscapeKeyDown={onCloseDialog}
      aria-labelledby="simple-dialog"
      PaperProps={{ classes: useStyles() }}
    >
      <div className={styles.container}>
        <h3 className={styles.title}>Campaign Status</h3>
        {
          options.map(({ text, Icon, checked }, index) => (
            <StatusOption
              key={text}
              text={text}
              Icon={Icon}
              checked={checked}
              onChange={onOptionChange(index)}
            />
          ))
        }
        <Button
          data-test-id="campaign-status-filter-apply-button"
          className={styles.submitButton}
          color="primary"
          onClick={() => {
            setCampaignStatusFilter(options.filter(opt => opt.checked).map(opt => opt.text));
            onCloseDialog();
          }}
        >
          Apply
        </Button>
      </div>
    </Dialog>
  );
};

export default CampaignStatusModal;
